import { Pie } from "react-chartjs-2";
import { FiBarChart2 } from "react-icons/fi";


const CustomerTypesCount = ({ data = [0, 0] }) => {
    const pieData = {
        labels: ['Existing Customer', 'New Customer'],
        datasets: [
            {
                label: 'Count ',
                data: data,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
                datalabels: {
                    display: false
                }
            },
        ],
    };
    return (
        <div className="customer-types-count-wrapper">
            <h5 className="mb-3">Booking Customer Types</h5>
            <div className="customer-types-count">
                <Pie
                    data={pieData}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                position: "bottom",
                            },
                        },
                    }}
                />
            </div>
        </div>
    )
}

export default CustomerTypesCount;